module.exports = (__webpack_require__(2410))(873);